import React, { Component } from 'react';
import { Helmet } from "react-helmet";

import AdminSidebar from '../components/AdminSidebar';
import Navbar from '../components/Navbar';
import NavbarAdmin from '../components/NavbarAdmin';

export default class Page extends Component{

    componentDidMount(){
        console.clear()
        //document.getElementById('root').scrollTop = false;
    }
    
    render(){
        const { isAdminPage, pageTitle, noPageHeader, children } = this.props
        const pageURL = window.location.href

        return(
            <div className="clearfix wrapper" id="main-wrap">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{ pageTitle }</title>
                    <link rel="canonical" href={ pageURL } />
                </Helmet>
                {
                    isAdminPage ?
                    <div 
                        className="clearfix" 
                        style={{ minHeight: '94vh', paddingRight: '1em' }}>

                        <NavbarAdmin />
                        <AdminSidebar />
                        
                        <div className="page-wrap col-sm-12">
                        { 
                            pageTitle && noPageHeader !== true ?
                                <div className="page-header">
                                    <h1>{ pageTitle }</h1>
                                </div>
                            : 
                                null
                        }
                        { children }
                        </div>
                    </div>
                :
                    <div className="clearfix">
                        <Navbar />
                        <div className="container">
                        { 
                            pageTitle && noPageHeader !== true ?
                                <div className="page-header">
                                    <h1>{ pageTitle }</h1>
                                </div>
                            : 
                                null
                        }
                        { children }
                        </div>
                    </div>
                }
            </div>
        )
    };
}


// WEBPACK FOOTER //
// ./src/components/Page.jsx